document.querySelectorAll('[data-pdp-quote]').forEach(function (section) {
  var cards = Array.prototype.slice.call(section.querySelectorAll('[data-quote-card]'));
  var texts = Array.prototype.slice.call(section.querySelectorAll('[data-quote-text]'));
  var total = cards.length;

  if (total < 2) return;

  var index = 0;

  function render() {
    cards.forEach(function (card, i) {
      var offset = (i - index + total) % total;
      card.setAttribute('data-pos', offset > 2 ? '3' : String(offset));
    });
    texts.forEach(function (text, i) {
      text.classList.toggle('is-active', i === index);
    });
  }

  function step(delta) {
    index = (index + delta + total) % total;
    render();
  }

  section.querySelectorAll('[data-quote-next]').forEach(function (btn) {
    btn.addEventListener('click', function () { step(1); });
  });

  section.querySelectorAll('[data-quote-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () { step(-1); });
  });

  // Swipe the deck on touch. Horizontal intent only, so vertical page scrolling
  // is never hijacked.
  var stack = section.querySelector('.pdp-quote__stack');
  if (stack) {
    var startX = 0;
    var startY = 0;
    var tracking = false;

    stack.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    stack.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    }, { passive: true });
  }
});
